import ApplicationController from 'javascript/controllers/application_controller';
import { loginWithFacebook, loginWithGoogle } from 'javascript/utils/oauth';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends ApplicationController {
  get redirectUrl() {
    return this.data.get('redirect');
  }

  facebook() {
    loginWithFacebook((url) => this.performRedirect(url));
  }

  google() {
    loginWithGoogle((url) => this.performRedirect(url));
  }

  performRedirect(url) {
    Turbo.visit(this.redirectUrl || url);
  }
}
